<template>
  <div class="pageWrap"  v-loading="loading">
    <div class="pagechange">
      <div class="redBlock"></div>
      <div class="headerText">油耗管理</div>
    </div>
    <div class="pagechange pagechange1">
      <div class="redBlock"></div>
      <div class="headerText">加油管理</div>
    </div>
    <div class="oildataPicker">
      <span class="name">日期</span>
      <el-date-picker
        v-model="value1"
        type="daterange"
        unlink-panels
        style="margin-left: 10px; margin-right: 10px"
        start-placeholder="选择开始日期"
        end-placeholder="选择结束日期"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptions">
      </el-date-picker>
      <el-button type="danger" @click="confirm">确认</el-button>
    </div>
    <div class="page1">
      <div class="left">
        <div class="size color1">
          <span class="date">{{weardayMaxDate?weardayMaxDate.replace('/','月')+'日':''}}</span>
          <span :class="wearmax*1>10000?'fontSize36': wearmax=='无数据'?'fontSize23':''">{{wearmax}}</span>
          <span class="column">单日最高油耗</span>
        </div>
        <div class="size color2">
          <span class="date">{{weardayMinDate?weardayMinDate.replace('/','月')+'日':''}}</span>
          <span :class="wearmix*1>10000?'fontSize36':wearmix=='无数据'?'fontSize23':''">{{wearmix}}</span>
          <span class="column">单日最低油耗</span>
        </div>
        <div class="size color3">
          <span :class="wearave*1>10000?'fontSize36':wearave=='无数据'?'fontSize23':''">{{wearave}}</span>
          <span class="column">日均油耗</span>
        </div>
        <div class="size color4">
          <span :class="weartotal*1>10000?'fontSize36':weartotal=='无数据'?'fontSize23':''">{{weartotal}}</span>
          <span class="column">累计总油耗</span>
        </div>
        <div class="unit">
          <span>单位：升</span>
        </div>
      </div>
      <!-- <div class="line" style="height:500px;background-color:#E1E1E1;width:1px;margin-top:80px"></div> -->
      <div class="right">
        <div class="search-form-group">
          <el-radio-group v-model="period" size="medium" @change="periodChange">
            <el-radio-button label="0">按日</el-radio-button>
            <!-- <el-radio-button label="1">按周</el-radio-button> -->
            <el-radio-button label="2">按月</el-radio-button>
            <el-radio-button label="3">查看详情</el-radio-button>
          </el-radio-group>
        </div>
        <div class="daypickCon" v-show="period==3">
          <div class="btn before" @click="choseDay(0)">前一天</div>
          <el-date-picker
            v-model="value2"
            :clearable="false"
            type="date"
            @change="dateChange"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions2"
            placeholder="选择日期">
          </el-date-picker>
          <div class="btn after" @click="choseDay(1)">后一天</div>
        </div>
        <div class="iconCon" v-show="period==3">
          <div class="icon icon1"></div>
          <div class="name">离线</div>
          <div class="icon icon2"></div>
          <div class="name">作业中</div>
          <div class="icon icon3"></div>
          <div class="name">怠速</div>
        </div>
        <div class="tableline">
          <ChartBarSign2 ref="chartBarSign2" @chartClick="barClick" :dataBar="debugPlan" :colorSet="colorLine" :legendGrid="legendGrid" :grid="grid"></ChartBarSign2>
        </div>
      </div>
    </div>
    <div class="page2" >
      <div class="left">
        <div class="size color1">
          <span :class="addmax*1>10000?'fontSize36':addmax=='无数据'?'fontSize23':''">{{addmax}}</span>
          <span class="column">最高单次加油</span>
        </div>
        <div class="size color2">
          <span :class="addmix*1>10000?'fontSize36':addmix=='无数据'?'fontSize23':''">{{addmix}}</span>
          <span class="column">最低单次加油</span>
        </div>
        <div class="size color3">
          <span :class="addave*1>10000?'fontSize36':addave=='无数据'?'fontSize23':''">{{addave}}</span>
          <span class="column">平均每次加油</span>
        </div>
        <div class="size color4">
          <span :class="addtotal*1>10000?'fontSize36':addtotal=='无数据'?'fontSize23':''">{{addtotal}}</span>
          <span class="column">累计加油</span>
        </div>
        <div class="unit">
          <span>单位：升</span>
        </div>
      </div>
      <!-- <div class="line" style="height:500px;background-color:#E1E1E1;width:1px;margin-top:80px"></div> -->
      <div class="right">
        <div class="searchContent">
          <el-button icon="el-icon-plus" type="danger" @click="openAddBox">增加记录</el-button>
          <!-- <el-button type="warning" @click="openPutBox" plain>修改</el-button> -->
          <el-button type="info" plain @click="openDelBox">删除</el-button>
        </div>
        <div class="listContain5">
          <div class="tablelistBody">
            <el-table
              :data="dataList"
              style="width: 100%"
              size="medium"
              height="440px"
              v-loading="listLoading"
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" min-width="4.507888%"></el-table-column>
              <el-table-column prop="order" label="序号" min-width="7.513148%"></el-table-column>
              <el-table-column prop="refuelVolume" label="加油量(L)" min-width="15.026296%"></el-table-column>
              <el-table-column prop="refuelTime" label="加油时间" min-width="18.782870%"></el-table-column>
              <el-table-column prop="operator" label="负责人" min-width="13.523666%"></el-table-column>
              <el-table-column prop="contact" label="联系电话" min-width="13.523666%"></el-table-column>
              <el-table-column prop="remark" label="备注" min-width="27.047332%">
                <template slot-scope="scope">
                  <span>{{scope.row.autoRemark}} {{scope.row.remark}}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" min-width="10.047332%">
                <template slot-scope="scope">
                  <div v-if="scope.row.type==0" class="jiaozheng" @click="pickFun(scope.row)">校正</div>
                  <div v-if="scope.row.type==1" class="jiaozheng" @click="putFun(scope.row)">修改</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pageblock">
            <el-pageCover
              class="pageBlock"
              :pageMsg="pageMsg"
              :page-sizes="[5, 10]"
              :layout="layout"
              @sizeChange="pageSizeChange"
              @currentChange="currentPageChange"
            ></el-pageCover>
          </div>
        </div>
      </div>
      <el-dialog
        :title="actionName"
        :visible.sync="addModBoxVisible"
        :close-on-click-modal="false"
        width="300px"
        top="25vh"
        custom-class="oildialog"
      >
        <div class="borderBlock borderPadding addAndEdit oil">
          <el-form
            :rules="rules"
            :model="modelObj"
            ref="addModForm"
            label-width="100px"
            @submit.native.prevent
          >
            <el-row>
              <el-col :span="24" v-if="actionName=='校正'">
                <el-form-item label="自动采集加油量（L）:" required label-width="100px" prop="autoVolume">
                  <span>{{modelObj.autoVolume}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="加油量（L）:" required label-width="100px" prop="refuelVolume">
                  <el-input :validate-event="false" v-model="modelObj.refuelVolume" maxlength="10" placeholder="请输入加油量"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="加油时间:" label-width="100px" required prop="refuelTime">
                  <el-date-picker
                    :validate-event="false"
                    v-model="modelObj.refuelTime"
                    type="datetime"
                    placeholder="请输入加油时间"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="操作人:" label-width="100px" prop="operator">
                  <el-input :validate-event="false" v-model="modelObj.operator" maxlength="10" placeholder="请输入操作人"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="联系方式:" label-width="100px" prop="contact">
                  <el-input :validate-event="false" v-model="modelObj.contact" maxlength="11" placeholder="请输入联系方式"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="备注:" label-width="100px" prop="remark">
                  <el-input v-model="modelObj.remark" type="textarea" autosize></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <div style="clear:both"></div>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addModBoxVisible = false">取消</el-button>
          <el-button type="primary" @click="addModSubmit">{{actionName}}</el-button>
        </span>
      </el-dialog>
      <div class="deletedialog">
        <el-dialog :title="actionName" :visible.sync="delModBoxVisible" top="34vh">
          <span class="el-icon-warning" style="color: #E96B5A;"></span>
          <span style="fontSize:16px">确认对所选记录进行删除吗?</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="delModBoxVisible = false">取 消</el-button>
            <el-button type="primary" @click="delModSubmit">{{actionName}}</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import { Message } from "element-ui";
import ChartBarSign2 from "../../../components/chart/chartBarSign2";
import { toChineseDate,dateTransfor1,dateTransfor } from "../../../utils/commons";
import ElPageCover from "../../../components/overall/ElPageCover";
import { getEquipDieselTable,addEquipDiesel,equipUpdateRefuel,equipDeleteRefuel,getEquipStatistics,getEquipOil} from "../../../utils/api";
export default {
  data() {
    return {
      multipleSelection: [],
      actionName: "",
      modelObj: {
        refuelTime:'',
      },
      addModBoxVisible: false,
      delModBoxVisible: false,
      period: "0",
      chartOption: {},
      debugPlan:{
        xAxis: ['12/01'],
        title: ["生产方量", "工作小时"],
        seriesType: ["bar","bar"],
        yAxisIndex: [0,1],
        yAxisUnit: ["方量: 方","时间: H"],
        data: [[75],[50]]
      },
      colorLine: ["cFFA940", "c597EF7"],
      legendGrid:[0,30],
      grid:[80,60,20,50],
      wearmax: "",
      wearmix: "",
      wearave: "",
      weartotal: "",
      weardayMaxDate:"",
      weardayMinDate:"",
      addmax: "",
      addmix: "",
      addave: "",
      addtotal: "",
      unit: "升",
      layout: " prev, pager, next, sizes, jumper , total",
      pageMsg: {
        pageSize: 5,
        pageNo: 1,
        totalRecords: 0,
      },
      listLoading:true,
      dataList: [],
      loading:false,
      timer:0, //定时器id
      value1:[],
      value2:'',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }],
        disabledDate: (time) => {
          return time.getTime() > Date.now();
        }
      },
      pickerOptions2:{
        disabledDate: (time) => {
          return time.getTime() > Date.now();
        }
      }
    };
  },
  props: ["code","workIndex"],
  computed: {
    rules: function () {
      return {
        refuelVolume: [{ required: true, message: "必填" }],
        refuelTime: [{ required: true, message: "必填" }],
      };
    },
  },
  created() {
    this.value1=[dateTransfor1(),dateTransfor()]
    this.value2=dateTransfor()
    console.log(this.value1,'values1')
  },
  mounted() {
    // this.getEquipOilline();
    this.getEquipOilTable();
    this.getEquipStatisticsFun();
    this.getEquipOilFun();
  },
  watch:{
      workIndex(val){
          if(val==0){
            // this.getEquipOilline();
            this.getEquipOilTable();
            this.getEquipStatisticsFun();
            this.getEquipOilFun();
          }
      },
      code(){
        this.value1=[dateTransfor1(),dateTransfor()]
        this.value2=dateTransfor()
        this.period='0'
        this.pageMsg= {
          pageSize: 5,
          pageNo: 1,
          totalRecords: 0,
        }
      }
  },
  components: { ChartBarSign2, ElPageCover },
  methods: {
    //时间范围选择器确认
    confirm(){
      if(this.value1==null){
        Message.warning('请选择时间段！')
        return
      }
      this.value2=this.value1[0]
      this.getEquipStatisticsFun()
      this.getEquipOilFun()
    },
    //选择前一天后一天日期
    choseDay(i){
      let date=''
      if(i==0){
        date=new Date(new Date(this.value2).getTime() - 60*60*1000*24)
      }else{
        if(new Date(this.value2+' 23:59:59').getTime()>Date.now()) return
        date=new Date(new Date(this.value2).getTime() + 60*60*1000*24)
      }
      let year=date.getFullYear();
      let month=date.getMonth()+1;
      let day=date.getDate();
      this.value2=year+'-'+(month<10?"0"+month:month)+'-'+(day<10?"0"+day:day)
      this.getEquipOilFun()
    },
    //
    dateChange() {
      // console.log(val)
      this.getEquipOilFun()
    },
    //点击echarts图上按日的某一天抛发事件
    barClick(e){
      if(this.period==0){
        this.period='3'
        this.value2=e.name
        this.getEquipOilFun()
      }
    },
    getEquipOilFun(){
      this.loading=true;
      let params={
        equipCode:this.code,
        startTime:this.value1[0]+' 00:00:00',
        endTime:this.value1[1]+' 23:59:59',
        mode:this.period,
      }
      if(this.period=='3'){
        params.startTime=this.value2+' 00:00:00'
        params.endTime=this.value2+' 23:59:59'
      }
      getEquipOil(params).then(res=>{
        if(res.data.code==200){
          if(this.period=='3'){
            let dataList=res.data.content.dataList
            let _xAxis=[]
            let _title=[]
            let _seriesType=[]
            let _yAxisIndex=[]
            let _yAxisUnit=[]
            let _data=[[]]
            //处理markArea
            let state=[];
            dataList[0].map(item=>{
              _xAxis.push(item.time) //横坐标
              _data[0].push(item.oil) //横坐标值
              state.push(item.state) //状态
            })
            let _markArea=[];
            let startNum=0;
            for(let i=0;i<state.length;i++){
                if((state[i]!=state[i+1])&&(i+1<state.length)){
                    let arr=[]
                    arr=[startNum,i+1,state[i]]
                    _markArea.push(arr)
                    startNum=i+1
                }else{
                    let bool=false
                    for(let j=startNum;j<state.length;j++){
                        if(state[startNum]!=state[j]){
                            bool=true
                        }
                    }
                    if(!bool){
                        let arr=[]	
                        arr=[startNum,state.length-1,state[startNum]]
                        _markArea.push(arr);
                        i=state.length-1
                    }
                }
            }
            let _markArea3=[] //将获取的索引转换成时间坐标
            _markArea.map(i=>{
                _markArea3.push([_xAxis[i[0]],_xAxis[i[1]],i[2]*1])
            })
            console.log(_markArea,_markArea3)
            _title=['油量']
            _seriesType=["line"]
            _yAxisIndex=[0]
            _yAxisUnit=["单位: L"]
            this.debugPlan={
              xAxis: _xAxis,
              title: _title,
              seriesType: _seriesType,
              yAxisIndex: _yAxisIndex,
              yAxisUnit: _yAxisUnit,
              period:this.period,
              markArea:_markArea3,
              data: _data,
              type:'oildetail'
            }
            this.colorLine= ["cFFA940","c96C4F6"]
            this.legendGrid=[0,90]
            this.grid=[30,60,40,50]
            if(dataList.length>1){
              let _data1=[]
              _xAxis.map(j=>{
                let index=dataList[1].findIndex(item=>{
                  return item.time==j
                })
                if(index>-1){
                  _data1.push(dataList[1][index].oil)
                }else{
                  _data1.push(null)
                }
              })
              console.log(_data1)
              this.debugPlan.data.push(_data1)
              this.debugPlan.yAxisIndex=[0,1]
              this.debugPlan.yAxisUnit=["单位: L","单位: L"]
              this.debugPlan.seriesType=["line","line"]
              this.debugPlan.title=['油量','原始油量']
            }
          }else{
            let list=res.data.content.dataList
              let _xAxis=[]
              let _title=[]
              let _seriesType=[]
              let _yAxisIndex=[]
              let _yAxisUnit=[]
              let _data=[[],[]]
              list.map(item=>{
                _xAxis.push(item.dateTag)
                _data[0].push(item.oil)
                _data[1].push(item.hourOil)
              })
              _title=['油耗','每小时油耗']
              _seriesType=["bar","bar"]
              _yAxisIndex=[0,1]
              _yAxisUnit=["单位: L","单位:L/H"]
              this.debugPlan={
                xAxis: _xAxis,
                title: _title,
                seriesType: _seriesType,
                yAxisIndex: _yAxisIndex,
                yAxisUnit: _yAxisUnit,
                period:this.period,
                data: _data
              }
              this.colorLine= ["cFFA940", "c597EF7"]
              this.legendGrid=[0,90]
              this.grid=[30,60,40,50]
          }
        }
        this.loading=false
      })
    },
    //获取四个方格数据
    getEquipStatisticsFun(){
        let params={
            equipCode:this.code,
            type:2,
            startTime:this.value1[0]+' 00:00:00',
            endTime:this.value1[1]+' 23:59:59',
        }
        getEquipStatistics(params).then(res=>{
            if(res.data.code==200){
                let info=res.data.content.info
                this.wearmax=info.dayMax==0?'无数据':(info.dayMax*1).toFixed(1);
                this.wearmix=info.dayMin==0?'无数据':(info.dayMin*1).toFixed(1);
                this.wearave=info.dayAverage==0?'无数据':(info.dayAverage*1).toFixed(1);
                this.weartotal=info.total==0?'无数据':(info.total*1).toFixed(1);
                this.weardayMaxDate=info.dayMaxDate;
                this.weardayMinDate=info.dayMinDate;
            }
        })
    },
    //分页
    pageSizeChange(size){
        this.pageMsg.pageSize=size;
        console.log(this.pageMsg,"pagesize")
        this.getEquipOilTable();
    },
    currentPageChange(index){
        this.pageMsg.pageNo=index;
        this.getEquipOilTable();
    },
    //周期变化
    periodChange(){
      if(this.value1==null && this.period!='3'){
        Message.warning('请选择时间段！')
        return
      }
      this.value2=this.value1[0]
      this.chartOption={};
      // this.getEquipOilline();
      this.getEquipOilFun();
    },
    
    //校正
    pickFun(item){
      this.addModBoxVisible = true;
      this.modelObj={
        refuelVolume:item.refuelVolume,
        remark:item.remark,
        contact:item.contact,
        operator:item.operator,
        id:item.id,
        equipCode: item.equipCode
      }
      this.modelObj.autoVolume = item.autoVolume
      this.modelObj.refuelTime = item.refuelTime.replace("年","-").replace("月","-").replace("日","")
      this.actionName = "校正";
      this.$refs["addModForm"].clearValidate();
    },
    //修改
    putFun(item){
      this.addModBoxVisible = true;
      console.log(item)
      this.modelObj={
        refuelTime:item.refuelTime.replace("年","-").replace("月","-").replace("日",""),
        refuelVolume:item.refuelVolume,
        remark:item.remark,
        contact:item.contact,
        operator:item.operator,
        id:item.id,
        equipCode: item.equipCode
      }
      this.actionName = "修改";
      this.$refs["addModForm"].clearValidate();
      
    },
    
    openAddBox() {
      this.addModBoxVisible = true;
      this.actionName = "新增记录";
      this.modelObj={
        autoVolume:null
      }
      this.$refs["addModForm"].clearValidate();
    },
    addModSubmit(){
      this.$refs["addModForm"].validate(valid => {
        if (valid) {
          let params={};
          if(this.actionName=="新增记录"){
            this.addModBoxVisible = false;
            params={...this.modelObj,equipCode:this.code};
            addEquipDiesel(params).then(res=>{
            if(res.data.code==200){
              this.getEquipOilTable();
              this.modelObj={}; 
              Message.success("添加成功");
            }
          }).catch(error=>{
              console.log(error);
              Message.error("添加失败");   
          })
          }else if(this.actionName=='修改'){
              this.addModBoxVisible = false;
              params={
                id:this.modelObj.id,
                equipCode: this.modelObj.equipCode,
                refuelVolume: this.modelObj.refuelVolume,
                refuelTime: this.modelObj.refuelTime,
                operator: this.modelObj.operator,
                contact: this.modelObj.contact,
                remark: this.modelObj.remark
              };
              equipUpdateRefuel(params).then(res=>{
              if(res.data.code==200){
                this.getEquipOilTable();
                  this.modelObj={}; 
                  Message.success("修改成功");
                }
              }
            ).catch(error=>{
                console.log(error);
                Message.error("修改失败");
            })
          }else if(this.actionName=='校正'){
              this.addModBoxVisible = false;
              params={
                id:this.modelObj.id,
                equipCode: this.modelObj.equipCode,
                refuelVolume: this.modelObj.refuelVolume,
                refuelTime: this.modelObj.refuelTime,
                operator: this.modelObj.operator,
                contact: this.modelObj.contact,
                remark: this.modelObj.remark,
                autoVolume: this.modelObj.autoVolume
              };
              equipUpdateRefuel(params).then(res=>{
              if(res.data.code==200){
                this.getEquipOilTable();
                  this.modelObj={}; 
                  Message.success("校正成功");
                }
              }
            ).catch(error=>{
                console.log(error);
                Message.error("校正失败");
            })
          }
        }
      })
    },
    // openPutBox() {
    //   this.actionName = "修改记录";
    //   if(this.multipleSelection.length==0){
    //       Message.warning("请选择修改项！")
    //       return;
    //     }else if(this.multipleSelection.length>1){
    //        Message.warning("仅支持单条记录修改！")
    //        return;
    //     }else{
    //       this.addModBoxVisible = true;
    //       this.$refs["addModForm"].clearValidate();
    //     }
    // },
    openDelBox() {
      if(this.multipleSelection.length==0){
          Message.warning("请选择删除项！")
          return;
      }
      this.delModBoxVisible = true;
      this.actionName = "删除记录";
    },
    delModSubmit(){
      let str="";
      str=this.multipleSelection.map((item)=>{
        return item.id
      }).join(",");
      this.delModBoxVisible = false;
      equipDeleteRefuel({ids:str}).then(res=>{
        if(res.data.content.dataList.length==0){
          Message.error("删除失败");
        }
        let deleteList = str.split(",")
        if(deleteList.length == this.dataList.length){
          if(this.pageMsg.pageNo > 1){
            this.pageMsg.pageNo = this.pageMsg.pageNo -1
          }else{
            this.pageMsg.pageNo = 1
          }
        }
        this.getEquipOilTable();
      }).catch(error=>{
        console.log(error);
        Message.error("删除失败");
      })
    },
    //表格勾选触发函数
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.modelObj = { ...this.multipleSelection[0] };
      this.modelObj.refuelTime=this.modelObj.refuelTime.replace("年","-").replace("月","-").replace("日","");
      
    },
    //油耗第一个页面
    // getEquipOilline(){
    //   this.loading=true;
    //   this.timer=setTimeout(()=>{this.loading=false},5000)
    //   getEquipDieselCost({code:this.code,mode:this.period}).then(res=>{
    //     if(!res.data.content){
    //       this.chartOption={};
    //       return;
    //     } 
    //     const info=res.data.content.info;
    //                const xAxisList = info.data.map((item) => item.name);
    //                const series = [{
    //                     name: "油耗",
    //                     type: "bar",
    //                     barWidth: 20,
    //                     data: info.data.map((item) => {
    //                     return item.values[0].toFixed(1);
    //                     }),
                        
    //                 },{
    //                     name: "每小时油耗",
    //                     type: "bar",
    //                     barWidth: 20,
    //                     data: info.data.map((item) => {
    //                     return (item.values[1]*100).toFixed(1);
    //                     }),
    //               }];
    //                this.chartOption={
    //                     dataZoomEnd: Math.min(100, Math.ceil((8 / xAxisList.length) * 100)),
    //                     legend: {
    //                     data: ["油耗","每小时油耗"],
    //                     right:"20%"
    //                     },
    //                     grid:{
    //                         top:40,
    //                         left:60
    //                     },
    //                     xAxis: [
    //                     {
    //                         type: "category",
    //                         data: xAxisList,
    //                         splitLine:{
    //                         show:false
    //                         },
    //                         axisLabel:{
    //                         lineStyle:{
    //                             color: '#878787'
    //                         }
    //                         },
    //                         axisLine:{
    //                         lineStyle:{
    //                             color:'#878787'
    //                         }
    //                         },
    //                         axisTick:{
    //                         show:false
    //                         }
    //                     },
    //                     ],
    //                     yAxis: [
    //                     {
    //                         type: 'value',
    //                         name: 'L',
    //                         // interval: '',
    //                         splitLine:{
    //                             show:false
    //                         },
    //                         axisLabel:{
    //                             lineStyle:{
    //                             color: '#878787'
    //                             },
    //                             formatter: '{value}'
    //                         },
    //                         axisLine:{
    //                             lineStyle:{
    //                             color:'#878787'
    //                             }
    //                         },
    //                         axisTick:{
    //                             show:false
    //                         }
    //                     },
                        
    //                     ],
    //                     series: series,
    //                 };
    //                 this.loading=false
    //                 clearTimeout(this.timer)
                   
    //   })    
    // },
    //油耗第二个页面查询
    getEquipOilTable(){
      this.listLoading=true;
      getEquipDieselTable({code:this.code,pageNo:this.pageMsg.pageNo,pageSize:this.pageMsg.pageSize}).then(res=>{
        if(!res.data.content){
          this.addmax="无数据";
          this.addmix="无数据";
          this.addave="无数据";
          this.addtotal="无数据";
          this.dataList=[];
          this.listLoading=false;
          return;
        }
        const info=res.data.content.info;
        this.addmax=(info.maxRefuel*1).toFixed(1);
        this.addmix=(info.minRefuel*1).toFixed(1);
        this.addave=(info.avgRefuel*1).toFixed(1);
        this.addtotal=(info.sumRefuel*1).toFixed(1);
        this.pageMsg={
          pageNo:info.data.pageNo,
          pageSize: info.data.pageSize,
          totalRecords: info.data.totalRecords,
        };
        this.listLoading=false;
        this.dataList=info.data.list.map((item,index)=>{
          return {
            id:item.id,
            equipCode:item.equipCode,
            refuelVolume:item.refuelVolume,
            order:(info.data.pageNo-1)*info.data.pageSize+index+1,
            refuelTime:item.refuelTime==null?'':toChineseDate(item.refuelTime+""),
            operator:item.operator,
            contact:item.contact,
            remark:item.remark,
            autoRemark:item.autoRemark,
            autoVolume:item.autoVolume,
            type:item.type
            }
        });
      }) 
    },
  },
  
};
</script>
<style lang="scss">
.daypickCon{
  .el-date-editor{
    width: 104px !important;
    height: 32px !important;
    .el-input__inner{
      height: 32px !important;
      padding-left:10px !important;
      padding-right:10px !important;
      line-height: 32px !important;
    }
    .el-input__prefix{
      display: none !important;
    }
  }
}
.oildataPicker{
  .el-date-editor{
    height: 32px !important;
    width: 330px !important;
    border-radius: 0 !important;
    .el-input__icon{
      line-height: 24px !important;
    }
    .el-range-separator{
      line-height: 24px !important;
    }
  }
  .el-button{
    width: 73px !important;
    height: 32px !important;
    margin-left: -10px;
  }
}
.oildialog{
  width: 500px !important;
  .el-dialog__footer{
    text-align: center !important;
  }
}
  .deletedialog{
    .el-dialog {
    width: 400px !important;
    }
  }
  .oil {
    .el-form-item{
      width: 480px !important;
    }
    .el-form-item__label{
      width: 160px !important;
    }
    .el-input {
      width: 220px !important;
    }
    .el-textarea{
      width: 220px !important;
      .el-textarea__inner{
        width: 220px !important;
      }
    }
    
}
.listContain5 {
      .tablelistBody{
        .el-table{
          height: 440px !important;
          .el-table__body-wrapper{
            height: 396px !important;
          }
          
        }
        .el-table::before{
            height: 0px !important;
          }
        // overflow: auto;
      }
  }
</style>
<style lang="scss" scoped="">
.pageWrap {
  width: 100%;
  height: auto;
  position: relative;
  // overflow-y: scroll;
  .pagechange {
    position: absolute;
    left: 10px;
    top: 25px;
    display: flex;
    .redBlock {
        height: 18px;
        width: 3px;
        background-color: #e96b5a;
        margin-right: 8px;
      }
      .headerText {
        color: #404040;
        font-family: Noto Sans SC;
        font-weight: medium;
        font-size: 16px;
        line-height: 18px;
        letter-spacing: 0px;
        text-align: left;
        font-weight: bold;
      }
  }
  .pagechange1{
    top: 658px;
  }
  .oildataPicker{
    position: absolute;
    top: 65px;
    left: 8px;
    .name{
      font-size: 14px;
    }
  }
  .page1 {
    display: flex;
    .left {
      width: 458px;
      height: 658px;
      padding: 120px 0px 50px 0px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .size {
        width: 213px;
        height: 213px;
        border-radius: 2px;
        margin: 0px 7px;
        font-size: 46px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #222222;
        display: flex;
        flex-direction: column;
        text-align: center;
        justify-content: center;
        .column {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #555555;
          padding-top: 20px;
        }
        .fontSize23{
          font-size: 23px;
        }
        .fontSize36{
          font-size: 36px;
        }
        .date{
            font-size: 16px;
        }
      }
      .color1 {
        background: #efeff8;
      }
      .color2 {
        background: #e5f0f9;
      }
      .color3 {
        background: #f8f3e4;
      }
      .color4 {
        background: #faecea;
      }
      .unit {
        margin-left: 15px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #222222;
      }
    }
    .right {
      width: 1400px;
      height: 568px;
      padding-top: 80px;
      padding-left: 10px;
      position: relative;
      .search-form-group {
        margin-left: 20px;
        margin-top: -18px;
      }
      .daypickCon{
        position: absolute;
        top: 63px;
        left: 400px;
        display: flex;
        .btn{
          border-radius: 2px;
          background: #FFFFFF;
          border: 1px solid #D9D9D9;
          width: 74px;
          height: 32px;
          line-height: 32px;
          font-size: 14px;
          text-align: center;
          &:hover{
            background: #E96B5A;
            color: white;
            cursor: pointer;
          }
        }
        .before{
          margin-right: 10px;
        }
        .after{
          margin-left: 10px;
        }
      }
      .iconCon{
        position: absolute;
        right: 55px;
        top: 68px;
        height: 16px;
        font-size: 14px;
        line-height: 17px;
        display: flex;
        .name{
          // width: 50px;
          margin-left: 5px;
          margin-right: 5px;
        }
        .icon{
          width: 30px;
          height: 16px;
        }
        .icon1{
          background: rgba(242, 242, 242, 0.6);
        }
        .icon2{
          background: rgba(0, 128, 0, 0.3);
        }
        .icon3{
          background: rgba(0, 0, 255, 0.3);
        }
      }
      .tableline {
        width: 100%;
        height: 450px;
        margin-top: 25px;
      }

      .searchContent {
        height: 65px;
        width: 80%;
        padding: 10.5px 17px;
      }
    }
  }
  .page2 {
    display: flex;
    .left {
      width: 458px;
      height: 538px;
      padding: 60px 0px 0px 0px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .size {
        width: 213px;
        height: 213px;
        border-radius: 2px;
        margin: 0px 7px;
        font-size: 46px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #222222;
        display: flex;
        flex-direction: column;
        text-align: center;
        justify-content: center;
        .column {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #555555;
          padding-top: 20px;
        }
        .fontSize23{
          font-size: 23px;
        }
        .fontSize36{
          font-size: 36px;
        }
        .date{
            font-size: 16px;
        }
      }
      .color1 {
        background: #efeff8;
      }
      .color2 {
        background: #e5f0f9;
      }
      .color3 {
        background: #f8f3e4;
      }
      .color4 {
        background: #faecea;
      }
      .unit {
        margin-left: 15px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #222222;
      }
    }
    .right {
      width: 1400px;
      height: 468px;
      padding-top: 45px;
      padding-left: 40px;
      position: relative;
      .search-form-group {
        margin-left: 20px;
        margin-top: -18px;
      }
      .daypickCon{
        position: absolute;
        top: 63px;
        left: 400px;
        display: flex;
        .btn{
          border-radius: 2px;
          background: #FFFFFF;
          border: 1px solid #D9D9D9;
          width: 74px;
          height: 32px;
          line-height: 32px;
          font-size: 14px;
          text-align: center;
          &:hover{
            background: #E96B5A;
            color: white;
            cursor: pointer;
          }
        }
        .before{
          margin-right: 10px;
        }
        .after{
          margin-left: 10px;
        }
      }
      .tableline {
        width: 90%;
        height: 400px;
        margin-top: 25px;
      }

      .searchContent {
        height: 65px;
        width: 80%;
        padding: 10.5px 17px;
      }
      .listContain5 {
        width: 98.5%;
        margin: 0 auto;
        position: relative;
        height: 440px;
        .tablelistBody {
          margin-left: 6px;
          height: 440px;
          .el-table .cell{
            .jiaozheng{
              width: 60px;
              height: 32px;
              background: #fde3e1;
              color: #E96B5A;
              border: 1px solid #efc9c9;
              border-radius: 10px;
              text-align: center;
              font-size: 14px;
              line-height: 32px;
              cursor: pointer;
            }
          }
        }
        .pageblock {
          position: absolute;
          top: 440px;
          right: 20px;
        }
      }
    }
  }
}
</style>